<template>
    <div class="SohState">
        <Title firstName="电池健康" lastName="SOH-STATE OF HEALTH" />
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>当前健康度</p>
                    <p>99<span> %</span></p>
                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" :seriesData="yData" unit="%" :xData="xTime"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title')
const Graph = () => import('../../../components/echarts/graph.vue')

export default {
    data(){
        return {
            chartId:'soh',
            seriesData:[99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, ]
        }
    },
    components:{
        Title,Graph
    },
    computed:{
        xTime(){
            let arr = []
            for(let i = 0;i<=24;i++){
                let one = i<10? '0'+i+':00':i+':00'
                arr.push(one)
            }
            return arr
        },
        yData(){
            return this.seriesData.splice(0, new Date().getHours() + 1)
        }
    },
    methods:{
    }
}
</script>

<style lang="less" scoped>
    
    .SohState{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                display: flex;
                justify-content: space-around;
                padding: 2.5vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 16vh;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>